import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RegisterPermissionType } from '@assetaccountant/api/models/register-permission-type';
import { AuthenticationService } from '@assetaccountant/core';
import { RegisterIntegration } from '@assetaccountant/core/models/register-integration';
import { TypedActivatedRoute } from '@assetaccountant/core/utils/route-utils';
import { DynamicsConnection } from '@assetaccountant/integrations/models/dynamics/dynamics-connection';
import { IntegrationType } from '@assetaccountant/integrations/models/integration-type';
import { MicrosoftDynamicsService } from '@assetaccountant/integrations/services/dynamics.service';
import { IntegrationsService } from '@assetaccountant/integrations/services/integrations.service';

@Component({
  selector: 'app-dynamics-launch-tenant',
  templateUrl: './dynamics-launch-tenant.component.html',
  styleUrls: ['./dynamics-launch-tenant.component.scss'],
  standalone: false,
})
export class DynamicsLaunchTenantComponent implements OnInit {
  @Input() connection?: DynamicsConnection;

  @Output() onConnectClicked = new EventEmitter();
  @Output() onDisconnectClicked = new EventEmitter();

  readonly RegisterPermission = RegisterPermissionType;

  constructor(
    @Inject(ActivatedRoute)
    private route: TypedActivatedRoute<{}, {}, { isRelog?: boolean }>,
    private authService: AuthenticationService,
    private dynamicsService: MicrosoftDynamicsService,
    private router: Router,
    private integrationService: IntegrationsService,
  ) {}

  get title() {
    return { pageTitle: `Dynamics App Launcher` };
  }

  async ngOnInit() {
    const returnUrl = new URL(location.href);

    if (!returnUrl.searchParams.has('isRelog')) {
      returnUrl.searchParams.append('isRelog', 'true');
    }

    // If the user is not authenticated, we need to authenticate them with the external identity provider.
    if (!this.authService.isAuthenticated()) {
      this.authService.init(returnUrl.toString(), { acr_values: 'idp:AzureAD' });
      return;
    }

    // Ensure the user is authenticated with the correct identity provider.
    if (!this.route.snapshot.queryParams.isRelog) {
      this.authService.logOut(returnUrl.toString());
      return;
    }

    const tenantId = this.authService.getTenantId();

    if (!tenantId) {
      console.log('No tenant in token!');
      // Todo: No tenantId in here, redirect to error page
      return;
    }

    this.integrationService
      .listIntegrations(IntegrationType.MicrosoftDynamics, tenantId)
      .subscribe(listConnectionsResponse => {
        this.handleConnections(listConnectionsResponse.integrations, tenantId);
      });
  }

  handleConnections(connections: RegisterIntegration[], tenantId: string) {
    if (connections.length === 0) {
      this.dynamicsService.initiateOAuth(location.href);
    } else if (connections.length === 1) {
      this.router.navigate([`/organisations/-/registers/${connections[0].registerId}`]);
    } else {
      this.router.navigate(['/organisations/-']);
    }
  }
}
